module.exports = __webpack_public_path__ + "static/img/32_pro.c1a2689.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/32_pro.jpg
// module id = IRz+
// module chunks = 0